import defineBankAvatar from './bankList.mapping'

const initialState = {
  isFetching: false,
  isFetched: true,
  isError: false,
  isSuccess: false,
  data: []
}

export const ACTION_TYPES = {
  BANK_ACCOUNT_REQUEST: 'BANK_ACCOUNT_REQUEST',
  BANK_ACCOUNT_SUCCESS: 'BANK_ACCOUNT_SUCCESS',
  BANK_ACCOUNT_ERROR: 'BANK_ACCOUNT_ERROR'
}

export const BANK_ACCOUNT_TYPES = {
  CurrentAccount: 'Conta Corrente',
  SavingsAccount: 'Conta Poupança'
}

export const getBankAccounts = (type, text) => ({
  type: ACTION_TYPES.BANK_ACCOUNT_REQUEST,
  payload: { type, text }
})

const getBankAccountType = ({ bankAccountType }) => {
  if (BANK_ACCOUNT_TYPES[bankAccountType]) return BANK_ACCOUNT_TYPES[bankAccountType]
  return bankAccountType === 0
    ? BANK_ACCOUNT_TYPES.CurrentAccount
    : BANK_ACCOUNT_TYPES.SavingsAccount
}

const normalizeBankAccounts = bankAccounts =>
  bankAccounts.map(account => {
    const normalizedAccountData = {
      ...account,
      tag: account.mainBankAccount,
      bankAccountType: getBankAccountType(account),
      bankAvatar: defineBankAvatar(account.bankNumber)
    }
    return normalizedAccountData
  })

const handleLoadAccounts = (state, payload) => {
  const data = (payload && payload.data) || []
  const newData = normalizeBankAccounts(data)

  const newState = {
    ...state,
    isFetching: false,
    isFetched: true,
    data: newData
  }

  return newState
}

const bankAccount = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.BANK_ACCOUNT_REQUEST:
      return { ...state, isFetching: true, isFetched: false }
    case ACTION_TYPES.BANK_ACCOUNT_SUCCESS:
      return handleLoadAccounts(state, payload)
    case ACTION_TYPES.BANK_ACCOUNT_ERROR:
      return { ...state, isFetching: false, isFetched: true }
    default:
      return state
  }
}

export default bankAccount
